"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var getSize = function (layout) {
    var _a = layout === 'full' ? [212, 55] : [145, 33], width = _a[0], height = _a[1];
    return {
        width: width + "px",
        height: height + "px",
    };
};
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps'], function (_a) {
    var compData = _a.compData, _b = _a.compProps, layout = _b.layout, theme = _b.theme;
    return ({
        channel: compData.youtubeChannelId,
        layout: layout,
        theme: theme === 'dark' ? 'dark' : 'default',
    });
});
exports.css = withCompInfo_1.withCompInfo(['compProps'], function (_a) {
    var layout = _a.compProps.layout;
    return getSize(layout);
});
//# sourceMappingURL=YouTubeSubscribeButton.js.map